import { useState, useContext } from 'react';
import './signin.css'; // Reutilizando o CSS da tela de login

import logo from '../../components/Header/Logo_oficial_CCB.png';
import { AuthContext } from '../../contexts/auth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc, setDoc } from 'firebase/firestore';
import bcrypt from 'bcryptjs';
import { db } from '../../services/firebaseConnection';

export default function PrimeiroAcesso() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { user, setUser } = useContext(AuthContext);
  const navigate = useNavigate();

  async function handleSetPassword(e) {
    e.preventDefault();

    if (newPassword.length < 6 || newPassword === '123456') {
      toast.error("A nova senha deve ter pelo menos 6 dígitos e não pode ser '123456'.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("As senhas não coincidem!");
      return;
    }
    try {
      const userRef = doc(db, 'User', user.uid);
      const updatedUserData = { ...user, password: bcrypt.hashSync(newPassword, 10) };
      await updateDoc(userRef, { password: updatedUserData.password }); // Atualiza apenas a senha
      setUser(updatedUserData);
      localStorage.setItem('@userLogado', JSON.stringify(updatedUserData));
    
      // Registrar o log na tabela Log
      const storedUser = JSON.parse(localStorage.getItem('@userLogado'));
      const { uid: userId, name: nameUser, email: userName } = storedUser;
      const logRef = doc(db, 'Log', `${userId}_${Date.now()}`);
      await setDoc(logRef, {
        userId,
        userName,
        nameUser,
        action: 'Primeiro-Login',
        timestamp: new Date().toISOString(),
      });
    
      toast.success('Senha atualizada com sucesso!');
      navigate('/home');
    } catch (error) {
      console.error('Erro ao atualizar a senha:', error);
      toast.error('Erro ao atualizar a senha!');
    }    
    
  }

  return (
    <div className="container-center">
      <div className="login">
        <div className="login-area">
          <img src={logo} alt="Logo do sistema de chamados" />
        </div>

        <form onSubmit={handleSetPassword}>
          <h1>Primeiro Acesso</h1>
          <input
            type="password"
            placeholder="Nova senha"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <input
            type="password"
            placeholder="Confirme a nova senha"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button type="submit">Atualizar Senha</button>
        </form>
      </div>
    </div>
  );
}
